import { render, staticRenderFns } from "./MtdList.vue?vue&type=template&id=72290cd8&"
import script from "./MtdList.vue?vue&type=script&lang=js&"
export * from "./MtdList.vue?vue&type=script&lang=js&"
import style0 from "./MtdList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports